import React, { Component } from 'react';
import { func, node, string } from 'prop-types';
import classNames from 'classnames';

import css from './OutsideClickHandler.module.css';

export default class OutsideClickHandler extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick(event) {
    // Check if click is inside our node
    if (this.node.contains(event.target)) {
      return;
    }
    
    // Check if click is on a Syncfusion dropdown popup (rendered to body)
    // Syncfusion popups have class 'e-popup' or 'e-dropdownbase'
    const syncfusionPopup = event.target.closest('.e-popup, .e-dropdownbase, .e-popup-open, .e-ddl');
    if (syncfusionPopup) {
      return;
    }
    
    this.props.onOutsideClick();
  }

  render() {
    const { rootClassName, className, children } = this.props;
    const classes = classNames(rootClassName || css.root, className);

    return (
      <div className={classes} ref={node => (this.node = node)}>
        {children}
      </div>
    );
  }
}

OutsideClickHandler.defaultProps = {
  rootClassName: null,
  className: null,
};

OutsideClickHandler.propTypes = {
  rootClassName: string,
  className: string,
  onOutsideClick: func.isRequired,
  children: node.isRequired,
};
